<template>
  <div class="mb-4">
    <template>
      <b-breadcrumb :items="breadcrumbItems" style="font-size:14px"></b-breadcrumb>
    </template>
    <!--#region -- Content ---->
    <div class="stage-header border-bottom mb-4">
      <!-- v-if="basicInfo !== null"-->
      <!--#region Header-->
      <div class="caption-label">
        Basic Information
        <!--
                    <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                  @click="clearPrimaryInfoInput"
                  v-b-tooltip.hover.right
                  title="click for reset data"></button>

        -->

      </div>
      <div class="row mb-4">
        <div class="col-6">
          <div class="header-col">
            <div>Salesforce ES</div>
            <div v-if="esTicketInfo !== null">
              <gtc-account-link v-if="_.get(esTicketInfo, 'opty_obj_id', null) != null"
                               :opportunityId="_.get(esTicketInfo, 'opty_obj_id', null)"
                               :opportunityName="esId" />
            </div>
          </div>
          <div class="header-col">
            <div>ES Status</div>
            <div v-if="esTicketInfo !== null">
              {{_.get(esTicketInfo, 'es_ticket_status', 'Not Processed Yet')}}
            </div>
          </div>
          <div class="header-col">
            <div>ES Creator</div>
            <div v-if="esTicketInfo !== null">
              {{ _.get(esTicketInfo, 'es_ticket_create_by', 'Not Processed Yet') }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="header-col">
            <div>FTIE ID</div>
            Ticket Not Processed Yet
          </div>
          <div class="header-col">
            <div>Close Reason</div>
            <!--
              <textarea class="w-100" v-if="esTicketInfo !== null" :disabled="true" v-model="esTicketInfo.close_reason"></textarea>
            -->

          </div>

        </div>
      </div>
    </div>

    <!--#endregion Header-->
    <div>
      <!-- #region: step one:  Primary Inforamtion-->

      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1
                      :variant="!isShowingCollapseFunc('accordion-1') ? 'secondary' : 'primary'"
                      :class="!isShowingCollapseFunc('accordion-1') ? 'text-dark' : 'text-white'"
                      style="text-align: left;">

              <b>
       <img src="../../../static/image/getac-icon-dash.svg"
         style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;" alt="Getac Dashboard Icon" />
                Step 1: Primary Inforamtion
              </b>
              (Please complete the required fields and proceed to next step)
            </b-button>
          </b-card-header>
          <b-collapse v-if="isShowingCollapseFunc('accordion-1')"
                      id="accordion-1" visible accordion="step-one" role="tabpanel">
            <b-card-body>
              <b-card-text><b>Prerequisite Information I</b></b-card-text>
              <div class="row mb-4">
                <div class="col-10" style="margin-left: 20px;">

                  <div class="header-col">
                    <div style="margin: 5.5px;">RSM/BDM<span class="text-danger pl-1">*</span></div>
                    <div v-if="defaultOptyInfo === null || _.get(defaultOptyInfo, 'opty_owner_name', null) === null">
                      <gtc-multi-select style="width: 35rem;" v-model="primaryInfoInputs.rsm" key-field="value" text-field="text" :multiple="false"
                                        :options="rsmOptions" select-class="w-100" @change="getOptions"></gtc-multi-select>
                    </div>
                    <div v-else style="margin: 5.5px;">
                      {{_.get(defaultOptyInfo, 'opty_owner_name', '')}}
                      <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                              v-b-tooltip.hover.right
                              title="The data was passed from Salesforce, can't be modify"></button>
                    </div>
                  </div>

                  <div class="header-col">
                    <div style="margin: 5.5px;">
                      Account Name
                    </div>
                    <div v-if="defaultOptyInfo === null
                         || _.get(defaultOptyInfo, 'account_id', null) === null">
                      <gtc-multi-select style="width: 35rem;" v-model="primaryInfoInputs.accountId" key-field="value" text-field="text" :multiple="false"
                                        :options="accountOptions" select-class="w-100" @change="onChangeByAccount"></gtc-multi-select>
                    </div>
                    <div v-else style="margin: 5.5px;">
                      {{_.get(defaultOptyInfo, 'account_name', '')}}
                    </div>

                    <div v-if="primaryInfoInputs.accountId !== null
                         && (defaultOptyInfo === null ||_.get(defaultOptyInfo, 'account_id', null) === null)" style="margin: 5.5px;">
                      <button type="button" class="btn btn-sm btn-primary"
                              @click="resetAccountOpty"
                              v-b-tooltip.hover.right
                              title="This will clean the chosen account and opportunity">
                        Reset
                      </button>
                    </div>

                  </div>

                  <div class="header-col">
                    <div style="margin: 5.5px;">Opportunity Name</div>
                    <div v-if="defaultOptyInfo === null || _.get(defaultOptyInfo, 'opty_id', null) === null">
                      <gtc-multi-select style="width: 35rem;" v-model="primaryInfoInputs.optyId" key-field="value" text-field="text" :multiple="false"
                                        :options="optyOptions" select-class="w-100" @change="onChangeByOpty"></gtc-multi-select>
                    </div>
                    <div v-else style="margin: 5.5px;">
                      {{_.get(defaultOptyInfo, 'opty_name', '')}}
                    </div>

                    <div v-if="primaryInfoInputs.optyId !== null && primaryInfoInputs.accountId !== null
                              && (defaultOptyInfo === null || _.get(defaultOptyInfo, 'opty_id', null) === null)" style="margin: 5.5px;">
                      <button type="button" class="btn btn-sm btn-primary"
                              @click="resetAccountOpty"
                              v-b-tooltip.hover.right
                              title="This will clean the chosen account and opportunity">
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="border-bottom my-4"></div>
              <b-card-text>
                <b>Prerequisite Information II</b>
                <code style="margin-left: 10px;">{{ text }}</code>
              </b-card-text>
              <div class="row mb-4">
                <div class="col-10" style="margin-left: 20px;">
                  <div class="header-col-wider ">
                    <div style="margin: 5.5px;">Why you need this engineering service<span class="text-danger pl-1">*</span></div>
                    <div v-if="sfdcInfoIsAllSet">
                      <b-form-select style="width: 70rem;"
                                     v-model="primaryInfoInputs.esPurpose"
                                     :options="whyNeedEsOptions"
                                     @change="onChangeIssueCategory"
                                     label="Request Type"></b-form-select>
                    </div>
                    <div v-else>
                      <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                              v-b-tooltip.hover.right
                              title="Please input above data first!"></button>
                    </div>
                  </div>

                  <div class="header-col-wider ">
                    <div style="margin: 5.5px;">What type of issue is matching question<span class="text-danger pl-1">*</span></div>
                    <div v-if="sfdcInfoIsAllSet">
                      <b-form-select style="width: 70rem;"
                                     v-model="primaryInfoInputs.typeOfIssue"
                                     :options="typeOfIssueOptions"
                                     @change="updateAutopilotChoice"
                                     label="Type of Issue"></b-form-select>
                    </div>
                  </div>

                  <div class="header-col-wider ">
                    <div style="margin: 5.5px;">Requirement stage<span class="text-danger pl-1">*</span></div>
                    <div v-if="sfdcInfoIsAllSet">
                      <b-form-select style="width: 70rem;"
                                     v-model="primaryInfoInputs.requirementStage"
                                     :options="requirementStageOptions"
                                     label="Requirement Stage"></b-form-select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text> -->

            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <!--#endregion-->
      <!-- #region: Step 2: Technical Information -->
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-2
                      :variant="!isShowingCollapseFunc('accordion-2') ? 'secondary' : 'primary'"
                      :class="!isShowingCollapseFunc('accordion-2') ? 'text-dark' : 'text-white'"
                      style="text-align: left;">
              <b>
       <img src="../../../static/image/getac-icon-dash-dark.svg"
         style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;" alt="Getac Dashboard Dark Icon" />
                Step 2: Technical Information
              </b>
              (Please complete the required fields and proceed to next step)
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-2" accordion="step-two" role="tabpanel">
            <!-- v-if="primaryInfoAllSet && isShowingCollapseFunc('accordion-2')" -->
            <b-card-body>
              <div class="row mb-4">
                <div class="col-6">

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">Engineering Service Issue / Requirement</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.es_issue"></textarea>
                          <div :class="classObject(_.get(esTicketInfo.tech_info, 'es_issue', ''), 2000)">
                            <span>You've input: {{ _.get(esTicketInfo.tech_info, 'es_issue', '') | getInputLength }}/2000</span>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">Impact</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.impact"></textarea>
                          <div :class="[classObject(_.get(esTicketInfo.tech_info, 'impact', ''), 255)]">
                            <span>You've input: {{ _.get(esTicketInfo.tech_info, 'impact', '') | getInputLength }}/255</span>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">3rd-Party Applications</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.third_party_application"></textarea>
                          <div :class="classObject(_.get(esTicketInfo.tech_info, 'third_party_application', ''), 255)">
                            <span>You've input: {{ _.get(esTicketInfo.tech_info, 'third_party_application', '') | getInputLength }}/255</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div>
                  <img src="../../../static/image/gtc-vertical-line.svg" alt="Vertical Line" />
                  <!-- style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;"-->
                </div>


                <div class="col-6" style="margin-left: -7px;">
                  <div class="header-col-mid">
                    <div>Owner</div>
                    <div v-if="esTicketInfo !== null">{{ _.get(esTicketInfo, 'es_ticket_create_by', null) }}</div>
                  </div>
                  <div class="header-col-mid">
                    <div>Priority</div>
                    <b-form-select v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null" style="width: 15rem;"
                                   v-model="esTicketInfo.tech_info.priority"
                                   :options="priority_options"
                                   label="Priority"></b-form-select>
                  </div>
                  <div class="header-col-mid">
                    <div>Due Date <span class="text-danger pl-1">*</span></div>
                    <input style="width: 15rem;"
                           v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null"
                           v-datepicker:from="date_from"
                           v-model="esTicketInfo.tech_info.due_date" />

                  </div>
                  <div class="header-col-mid">
                    <div>Model<span class="text-danger pl-1">*</span></div>
                    <b-form-select v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null" style="width: 15rem;"
                                   v-model="esTicketInfo.tech_info.model"
                                   :options="_.get(primaryInfoInputs, 'modelList', null)"
                                   label="Model"></b-form-select>
                  </div>

                  <!-- ✅NEW: ETO Precheck GCS Design field, placed right of Model -->
                  <div v-if="etoPrecheckEnable" class="header-col-mid">
                    <div>
                      <span style="
                          display: inline-flex;
                          align-items: center;
                          font-family: 'Arial Black', 'Helvetica Neue', sans-serif;
                          color: #005288;
                          text-transform: uppercase;
                          font-size: 11px;
                          font-weight: 900;
                          letter-spacing: -0.5px;
                          line-height: 1;
                          gap: 1px;
                        ">
                        <span>ETO</span>
                        <span style="font-size: 9px; font-weight: 700; align-self: flex-end; padding-bottom: 6px;">Pre</span>
                        <span style="
                              width: 11px;
                              height: 11px;
                              background-color: #89d94c;
                              border-radius: 2px;
                              display: inline-flex;
                              align-items: center;
                              justify-content: center;
                              position: relative;
                              transform: translateY(1px);
                              flex-shrink: 0;
                            ">
                          <span style="
                                    display: block;
                                    width: 3px;
                                    height: 5px;
                                    border: solid white;
                                    border-width: 0 2px 2px 0;
                                    transform: rotate(45deg);
                                    margin-top: -2px;
                                  "></span>
                        </span>
                        <sup style="font-size: 7px; font-weight: 700; margin-left: 1px;">®</sup>
                      </span>
                    </div>
                    <b-form-select v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null"
                                   style="width: 15rem;"
                                   v-model="esTicketInfo.tech_info.gcs_design"
                                   :options="[
                        { value: null, text: 'Please select', disabled: true },
                        { value: 'GCS Design 1', text: 'GCS Design 1' },
                        { value: 'GCS Design 2', text: 'GCS Design 2' },
                        { value: 'GCS Design 3', text: 'GCS Design 3' }
                      ]"></b-form-select>
                  </div>

                  <!-- END REGION -->

                  <div class="header-col-mid">
                    <div>Configuration</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.configuration"></textarea>
                          <div :class="classObject(_.get(esTicketInfo.tech_info, 'configuration', ''), 1000)">
                            <span>You've input: {{ _.get(esTicketInfo.tech_info, 'configuration', '') | getInputLength }}/1000</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Detailed Spec</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.detailed_spec"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Customer Application / User Scenario</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.user_scenario"></textarea>
                          <div :class="classObject(_.get(esTicketInfo.tech_info, 'user_scenario', ''), 1000)">
                            <span>You've input: {{ _.get(esTicketInfo.tech_info, 'user_scenario', '') | getInputLength }}/1000</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <!--#endregion-->
      <!-- #region: step-three: additional info for customization -->
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-3
                      :variant="!isShowingCollapseFunc('accordion-3') ? 'secondary' : 'primary'"
                      :class="!isShowingCollapseFunc('accordion-3') ? 'text-dark' : 'text-white'"
                      style="text-align: left;">
              <b>
       <img src="../../../static/image/getac-icon-dash-dark.svg"
         style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;" alt="Getac Dashboard Dark Icon" />
                Additional Information for Customization
              </b>
              (Please complete the required fields if you request a customization)
            </b-button>
          </b-card-header>
          <!-- v-if="primaryInfoAllSet && isShowingCollapseFunc('accordion-3')"-->
          <b-collapse id="accordion-3" accordion="customization-info" role="tabpanel">
            <b-card-body>
              <div class="row mb-4">
                <div class="col-6">

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">Delivery Date of POC<span class="text-danger pl-1">*</span></div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'customization_info', null) !== null">
                          <input class="w-100" style="height: 35px;" v-datepicker:from="date_from" v-model="esTicketInfo.customization_info.poc_delivery_date" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">ECO System<span class="text-danger pl-1">*</span></div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'customization_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;" v-model="esTicketInfo.customization_info.eco_system"></textarea>
                          <div :class="[classObject(_.get(esTicketInfo.customization_info, 'eco_system', ''), 255)]">
                            <span>You've input: {{ _.get(esTicketInfo.customization_info, 'eco_system', '') | getInputLength }}/255</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div v-if="selectedAutopilot === 'Yes' ">
                  <img src="../../../static/image/gtc-vertical-line-sectsol.svg" alt="Sector Solution Vertical Line" />
                  <!--<img src="../../../static/image/gtc-vertical-line-customization.svg" />
  -->
                  <!-- style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;"-->
                </div>
                <div v-else>
                  <img src="../../../static/image/gtc-vertical-line-customization.svg" alt="Customization Vertical Line" />
                </div>


                <div class="col-6" style="margin-left: -7px;">
                  <div class="header-col-mid">
                    <div>Delivery Date of MP<span class="text-danger pl-1">*</span></div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'customization_info', null) !== null">
                          <input class="w-100" style="height: 35px;" v-datepicker:from="date_from" v-model="esTicketInfo.customization_info.mp_delivery_date" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="header-col-mid">
                    <div>Detailed Customization Request<span class="text-danger pl-1">*</span></div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'customization_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;" v-model="esTicketInfo.customization_info.customization_request"></textarea>
                          <div :class="[classObject(_.get(esTicketInfo.customization_info, 'customization_request', ''), 1000)]">
                            <span>You've input: {{ _.get(esTicketInfo.customization_info, 'customization_request', '') | getInputLength }}/1000</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid" style="margin-top: 25px;">
                    <div>
                      Microsoft Autopilot
                      <span v-if="ifHasAutopilotReq" class="text-danger pl-1">*</span>
                    </div>
                    <div class="flex-fill">
                      <div class="row">
                        <div class="col">
                          <div>
                            Does this customization request include the MS Autopilot registration service
                          </div>
                          <div class="flex-fill">
                            <div class="flex-wrap" v-if="esTicketInfo !== null">
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio-group id="autopilot-radio-1"
                                                    v-model="esTicketInfo.sa_selected_autopilot"
                                                    :options="autopilotOptions"
                                                    :aria-describedby="ariaDescribedby"
                                                    name="autopilot-radio"
                                                    :disabled="!displayAutopilotTick"></b-form-radio-group>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="header-col-mid" style="margin-top: 25px;" v-if="selectedAutopilot === 'Yes' ">
                    <div>
                      Autopilot Requirements
                      <span v-if="ifHasAutopilotReq" class="text-danger pl-1">*</span>
                    </div>
                    <div class="flex-fill">
                      <div v-if="selectedAutopilot === 'Yes' ">
                        <div v-if="ifHasAutopilotReq" class="alert alert-danger alert-dismissible" role="alert">
                          <strong>Attention!</strong>
                          The old consent link has been expired by Microsoft (MSFT passively notified us on 28th Feb 2024). Here is the new consent link we should provide to our customer for Autopilot Consent:
                          <a href="https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation" target="_blank">https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation</a>
                          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                          </button>
                        </div>
                        <!-- Accept Getac consent Link:  -->
                        <div class="row">
                          <div class="col">
                            <div class="flex-fill">
                              <div class="flex-wrap">
                                <div class="text-primary pl-1">
                                  Consent need to be accepted by the customer to authorize Getac as partner within the customer’s environment.
                                  <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                                          @click="showAutopilotInfoModal()"
                                          v-b-tooltip.hover.bottom
                                          title="Click for more info"></button>
                                  <b-modal ref="ConsentDetailModal"
                                           centered size="lg" :title="'About Customer Consent'" button-size="sm" hide-footer>
                                    <div class="d-block">
                                      <div v-html="safeHtml(autopilot_consent_text)"></div>
                                    </div>
                                  </b-modal>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <div>Tenant ID <span class="text-danger pl-1">*</span></div>
                            <div class="flex-fill">
                              <div class="flex-wrap">
                                <div v-if="esTicketInfo !== null && _.get(esTicketInfo, 'autopilot_info', null) !== null">
                                  <textarea class="w-100" v-model="esTicketInfo.autopilot_info.tenant_id"></textarea>
                                  <div :class="[classObject(_.get(esTicketInfo.autopilot_info, 'tenant_id', ''), 50)]">
                                    <span>You've input: {{ _.get(esTicketInfo.autopilot_info, 'tenant_id', '') | getInputLength }}/50</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div>Tenant Domain <span class="text-danger pl-1">*</span></div>
                            <div class="flex-fill">
                              <div class="flex-wrap">
                                <div v-if="esTicketInfo !== null && _.get(esTicketInfo, 'autopilot_info', null) !== null">
                                  <textarea class="w-100" v-model="esTicketInfo.autopilot_info.tenant_domain"></textarea>
                                  <div :class="[classObject(_.get(esTicketInfo.autopilot_info, 'tenant_domain', ''), 200)]">
                                    <span>You've input: {{ _.get(esTicketInfo.autopilot_info, 'tenant_domain', '') | getInputLength }}/200</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div>Customer IT Admin Email <span class="text-danger pl-1">*</span></div>
                            <div class="flex-fill">
                              <div class="flex-wrap">
                                <div v-if="esTicketInfo !== null && _.get(esTicketInfo, 'autopilot_info', null) !== null">
                                  <textarea class="w-100" v-model="esTicketInfo.autopilot_info.admin_email_val"></textarea>
                                  <div :class="[classObject(_.get(esTicketInfo.autopilot_info, 'admin_email_val', ''), 200)]">
                                    <span>You've input: {{ _.get(esTicketInfo.autopilot_info, 'admin_email_val', '') | getInputLength }}/200</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div>Group Tag <span v-if="esTicketInfo.autopilot_info.group_val !== null" style="font-style:italic">(Optional, If left blank, the group tag will not be set for customer.)</span></div>
                            <div class="flex-fill">
                              <div class="flex-wrap">
                                <div v-if="esTicketInfo !== null && _.get(esTicketInfo, 'autopilot_info', null) !== null">
                                  <textarea class="w-100"
                                            :placeholder="autoPilotGroupTagPlaceholders"
                                            v-model="esTicketInfo.autopilot_info.group_val"></textarea>
                                  <div :class="[classObject(_.get(esTicketInfo.autopilot_info, 'group_val', ''), 200)]">
                                    <span>You've input: {{ _.get(esTicketInfo.autopilot_info, 'group_val', '') | getInputLength }}/200</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>


                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <!--#endregion-->
      <!-- #region: step-four: additional info for sector solution -->
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-4
                      :variant="!isShowingCollapseFunc('accordion-4') ? 'secondary' : 'primary'"
                      :class="!isShowingCollapseFunc('accordion-4') ? 'text-dark' : 'text-white'"
                      style="text-align: left;">
              <b>
                <img src="../../../static/image/getac-icon-dash-dark.svg"
                     style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;" alt="Getac Dashboard Dark Icon" />
                Additional Information for Sector Solution
              </b>
            </b-button>
          </b-card-header>
          <!-- v-if="isShowingCollapseFunc('accordion-4')" -->
          <b-collapse id="accordion-4" accordion="sector-solution-info" role="tabpanel">
            <b-card-body>
              <div class="row mb-4">
                <div class="col-6">
                  <div class="header-col-mid">
                    <div>Industry</div>
                    <div>{{_.get(primaryInfoInputs, 'industry', null)}}</div>
                  </div>
                  <div class="header-col-mid">
                    <div>Vertical</div>
                    <div>{{_.get(primaryInfoInputs, 'vertical', null)}}</div>
                  </div>
                  <div class="header-col-mid">
                    <div>User group</div>
                    <div>{{_.get(esTicketInfo, 'sector_solution_info.user_group', null)}}</div>
                  </div>

                  <div class="header-col-mid">
                    <div>Environment</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100">
                          <b-link v-b-tooltip.hover :title="_.get(esTicketInfo, 'sector_solution_info.placeholders.environment.text', '')">
                            Hover over to see an example
                          </b-link>
                        </div>
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.environment.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.environment">

                          </textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Scenario</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.scenario.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.scenario"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Behavior</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.behavior.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.behavior"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Pain Point</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.pain_point.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.pain_point"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div>
                  <img src="../../../static/image/gtc-vertical-line-sectsol.svg" alt="Sector Solution Vertical Line"/>
                </div>


                <div class="col-6" style="margin-left: -7px;">

                  <div class="header-col-mid">
                    <div>User Need</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100">
                          <b-link v-b-tooltip.hover :title="_.get(esTicketInfo, 'sector_solution_info.placeholders.user_need.text', '')">
                            Hover over to see an example
                          </b-link>
                        </div>

                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.user_need.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.user_need"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Imaging Process</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100">
                          <b-link v-b-tooltip.hover :title="_.get(esTicketInfo, 'sector_solution_info.placeholders.imaging_process.text', '')">
                            Hover over to see an example
                          </b-link>
                        </div>
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.imaging_process.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.imaging_process"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Installation Process</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100">
                          <b-link v-b-tooltip.hover :title="_.get(esTicketInfo, 'sector_solution_info.placeholders.installation_process.text', '')">
                            Hover over to see an example
                          </b-link>
                        </div>
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.installation_process.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.installation_process"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Deployment Plan</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100">
                          <b-link v-b-tooltip.hover :title="_.get(esTicketInfo, 'sector_solution_info.placeholders.deployment_plan.text', '')">
                            Hover over to see an example
                          </b-link>
                        </div>

                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.deployment_plan.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.deployment_plan"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>User Workflow</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.user_workflow.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.user_workflow"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Work Details</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.work_details.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.work_details"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <!--#endregion-->


    </div>
    <!--#endregion-->
    <div class="fixed-bottom d-print-none">
      <div class="row py-2 bg-gray-150 px-4 border-top border-gray-550">
        <div class="col-auto ml-auto p-0"></div>
        <div class="col-auto">
          <button type="button" class="btn btn-success min-w-6" @click="validate() && lengthValidate() && saveData()">Save</button>
        </div>
      </div>
    </div>
  </div>
  <!--#endregion-->

</template>
<script>
  import * as moment from 'moment/moment';
  import { safeHtml } from '@/helpers/vue-safehtml';
  export default {
    data() {
      return {
        esId: '',
        sfdcOptyEsId: '',
        sfdcOptyId: '',//encodeURIComponent(this.$route.params.opty_id),
        defaultOptyInfo: null,
        ftieId: '',
        detailId: '',
        requestFormId: '',
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        actionEnable: false,
        createBy: null,
        date_from: null,
        updateSuccessNotification: null,
        updateFailedNotification: null,
        priority_options: ['High', 'Medium', 'Low'],
        // isShowingCollapseTest: false,
        isShowingCollapse: {
          'accordion-1': true,
          'accordion-2': false,
          'accordion-3': false,
          'accordion-4': false
        },
        collapseFulfillStatus: {
          'accordion-1': false,
          'accordion-2': false,
          'accordion-3': false,
          'accordion-4': false
        },

        text: `(Please note that the customization request only open to the ticket which has opportunity.)
        `,
        breadcrumbItems: [
          {
            text: 'New Engineering Service',
            active: true,
          },
        ],

        autopilot_consent_text: ` <ul>
<h5>Microsoft requires customer consent before allowing Getac to register devices for Autopilot.</h5>

<li>If customer have not provided consent, please provide link below and guide them to complete this step.
<br/>
<span style="font-weight:bold; color: red">[New Consent Link Updated by Microsoft Since 2024 Feb] </span>
<a href="https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation">
         https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation </a>

<br/><b>(THIS LINK WILL ONLY WORK FOR AZURE GLOBAL ADMINISTRATORS. IT WILL BE BROKEN FOR EVERYONE ELSE)</b>
  </li>
<li>Here is a Microsoft Article that shows the process.
If your customer has never performed this process before, this link will be an excellent guide<br/>
<a href="https://docs.microsoft.com/en-us/mem/autopilot/registration-auth">https://docs.microsoft.com/en-us/mem/autopilot/registration-auth</a>
</li>
<li>If your customer does not know how to get their Tenant ID, Name, or Admin Email,
please send them the following:<br/>
<a href="https://learn.microsoft.com/en-us/azure/active-directory/fundamentals/how-to-find-tenant">https://learn.microsoft.com/en-us/azure/active-directory/fundamentals/how-to-find-tenant</a>
</li>
</ul>`,
        searching: false,
        searchingNre: false,
        searchingStdSku: false,
        esTicketInfo: null,
        esTicketOriginalInfo: null,
        basicInfo: null,
        refSkuList: null,
        selectedRefSkuIndex: null,
        selectedRefSkuItems: [],
        saveRefSkuError: null,
        skuPnListForNre: null,
        sfdcProducts: null,
        nreRemarkWarning: null,
        autopilotOptions: [{ text: 'No', value: 'No' }, { text: 'Yes', value: 'Yes' },],
        /* region:fake data*/
        readOnly: false,
        selectRsm: null,
        configuration: '',
        rsmOptions: [],
        optyOptions: [],
        optyOptionsTmp: [],
        all_model_list: [],
        optyInfoObjList:[],
        accountOptions: [],
        accountOptionsTmp: [],
        issueCategoryList: [],
        //whyNeedEsOptions: [],
        whyNeedEsOptionsTmp: [],
        typeOfIssueOptions: [],
        requirementStageOptions: [],
        attach_files: [
          { file_name: 'test_attach_pdf.pdf' },
          { file_name: 'test_attach_csv.csv' },
        ],
        attachFileFields: [
          {
            key: 'file_name', label: 'File Name',
            // thClass: 'align-middle',
            tdClass: 'min-w-187',
            thStyle: { width: "80%" },
            sortable: true
          },
          { key: 'delete', label: '', thClass: 'align-middle', sortable: false },
        ],
        /* end region */

        /* region: input for step 1*/
        primaryInfoInputs: {
          rsm: null,
          accountId: null,
          optyId: null,
          vertical: null,
          industry: null,
          modelList: null,

          esPurpose: null,
          typeOfIssue: null,
          requirementStage: null,

          //isAllSet: false,
        },
        /* end region */
        autoPilotGroupTagPlaceholders: 'Optional. If left blank, the group tag will not be set for customer.',

      };
    },
    created() {
      let self = this;
      if ((this.userRoles && _.indexOf(this.userRoles, 'Admin') > -1)
        || (this.userRoles && _.indexOf(this.userRoles, 'ES_PM') > -1)
        || (this.userRoles && _.indexOf(this.userRoles, 'ES_PM_Leader') > -1)
        || (this.userRoles && _.indexOf(this.userRoles, 'GRO_SA') > -1)
        || (this.userRoles && _.indexOf(this.userRoles, 'GRO_SA_Leader') > -1)
        || (this.userRoles && _.indexOf(this.userRoles, 'HQ_Sales') > -1)
        || (this.userFunctions && _.indexOf(this.userFunctions, 'ES PM Leader') > -1)
        || (this.userFunctions && _.indexOf(this.userFunctions, 'Tech Leader') > -1)
        || (this.userFunctions && _.indexOf(this.userFunctions, 'Getac Sales Manager') > -1)
        || (this.userFunctions && _.indexOf(this.userFunctions, 'GRO TOP Manager') > -1)
      ) {
        //         || (this.userRoles && _.indexOf(this.userRoles, 'SFDC_USERS') > -1)
        self.accessSfdc = true;
      } else {
        window.alert("You don't have the permission to create an Engineering Service. Please contact system administrators power@getac.com and alice.cy.lee@getac.com.tw if you still want to raise a ticket.");
        window.location.href = self.frontEndUrlToUse + 'engineering-services/dashboard';
      }

      self.sfdcOptyId = encodeURIComponent(this.$route.params.opty_id);
      //let today = moment();
      self.date_from = moment().format('YYYY-MMM-DD');
      //self.date_to = moment().format('YYYY-MMM-DD');
      let callback = () => {
        if (!self.readOnly) {
          console.log("!self.readOnly!");
        }
        //#region

        $(window).on('beforeunload', function () {
          if (!self.readOnly && JSON.stringify(self.esTicketInfo) !== JSON.stringify(self.esTicketOriginalInfo)) {
            return "You have made changes on this page that you have not yet confirmed.\nIf you navigate away from this page you will lose your unsaved changes";
          }
        });
        self.actionEnable = self.checkActionEnable();

        console.log("ES Ticket Page actionEnable:");
        console.log(self.actionEnable);
        //#endregion
      };
      self.getPage();
    },
    computed: {
      loginUser() {
        return _.get(this.$store, 'state.username', null);
      },
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      },
      selectedAutopilot: {
        get() {
          if (this.esTicketInfo !== null) {
            return _.get(this.esTicketInfo, 'sa_selected_autopilot', null);
          } else {
            return null;
          }
        },
        set(selectedAutopilotVal) {
          if (this.esTicketInfo !== null) {
            _.get(this.esTicketInfo, 'sa_selected_autopilot', null);
          }
        }
      },
      displayAutopilotTick() {
        if (_.isNull(_.get(this.primaryInfoInputs, 'esPurpose', null)) || _.get(this.primaryInfoInputs, 'esPurpose', null) === 'Asks to customize existing Getac products for special items.' || _.get(this.primaryInfoInputs, 'esPurpose', null) === 'Asks for a new Getac PN/BOM since it is not ready on eQuote yet.') {
          return true;
        }
        else {
          if (this.esTicketInfo !== null) {
            _.set(this.esTicketInfo, 'sa_selected_autopilot', null);
          }
          return false; // non customization purpose ES, do not display the autopilot tick
        }
      },
      ifHasAutopilotReq() {
        if (!_.isNull(_.get(this.primaryInfoInputs, 'typeOfIssue', null)) &&
          'Software - Autopilot' === _.get(this.primaryInfoInputs, 'typeOfIssue', null)) {
          // "'Software - Autopilot' === self.esTicketInfo.primary_info.matching_issue"
          return true;
        } else {
          if (this.selectedAutopilot === 'Yes' || (this.esTicketInfo !== null && _.get(this.esTicketInfo, 'sa_selected_autopilot', null) === 'Yes')) {
            return true;
          }
          else {
            return false
          }
        }
      },
      //  Region: New Add ETO PreCehck flag and options when specific model has been choosen
      etoPrecheckEnable() {
        if (!_.isNull(_.get(this.esTicketInfo, 'tech_info.model', null)) &&
          'UX10G5' === _.get(this.esTicketInfo, 'tech_info.model', null) &&
          'PRD' !== this.$session.get('mode')) {
          // "'Software - Autopilot' === self.esTicketInfo.primary_info.matching_issue"
          return true;
        } else {
          return false;
        }
      },
      // End of Region

      sfdcInfoIsAllSet() {
        if ((!_.isNull(_.get(this.primaryInfoInputs, 'rsm', null)) &&
          (!_.isNull(_.get(this.primaryInfoInputs, 'accountId', null)) || !_.isNull(_.get(this.primaryInfoInputs, 'optyId', null))))) {
          return true;
        }
        else {
          return false
        }
      },

      primaryInfoAllSet() {
        if (!_.isNull(_.get(this.primaryInfoInputs, 'esPurpose', null)) &&
          !_.isNull(_.get(this.primaryInfoInputs, 'typeOfIssue', null)) &&
          !_.isNull(_.get(this.primaryInfoInputs, 'requirementStage', null))) {

          _.set(this.isShowingCollapse, 'accordion-2', true);
          _.set(this.collapseFulfillStatus, 'accordion-1', true);

          return true;
        }
        else {
          _.set(this.isShowingCollapse, 'accordion-2', false);
          _.set(this.collapseFulfillStatus, 'accordion-1', false);
          return false
        }

      },

      whyNeedEsOptions() {
        //return this.whyNeedEsOptions.filter(data => data.name != 'Ragnar'); deal with array of obj
        if (_.isNull(_.get(this.primaryInfoInputs, 'optyId', null))
          || _.isNull(_.get(this.primaryInfoInputs, 'optyId.value', null))
          || _.get(this.primaryInfoInputs, 'optyId.value', null) === '') {
          let customization = 'Asks to customize existing Getac products for special items.';
          /*
          let tmp = this.whyNeedEsOptionsTmp.filter(function (value, index, arr) {
            return value !== 'Asks to customize existing Getac products for special items.';
          });*/

          let tmp = this.whyNeedEsOptionsTmp.filter(function (item) {
            return item !== customization;
          })
          //console.log("optyId get null, whyNeedEsOptions tmp = ");
          //console.log(tmp);
          return JSON.parse(JSON.stringify(tmp));
          // return tmp;
        }
        else {
          return JSON.parse(JSON.stringify(this.whyNeedEsOptionsTmp));
        }
      },
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      showAutopilotInfoModal() {
        this.$refs['ConsentDetailModal'].show()
      },
      classObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },
      clearIssueCategoy() {
        let self = this;
        _.set(self.primaryInfoInputs, 'esPurpose', null);
        _.set(self.primaryInfoInputs, 'typeOfIssue', null);
        _.set(self.primaryInfoInputs, 'requirementStage', null);
      },
      clearVerticalIndustryModelList() {
        let self = this;
        _.set(self.primaryInfoInputs, 'vertical', null);
        _.set(self.primaryInfoInputs, 'industry', null);
        _.set(self.primaryInfoInputs, 'modelList', null);
      },
      clearPrimaryInfoInput() {
        let self = this;
        _.set(self.primaryInfoInputs, 'rsm', null);
        _.set(self.primaryInfoInputs, 'accountId', null);
        _.set(self.primaryInfoInputs, 'optyId', null);
        self.clearVerticalIndustryModelList();
        self.clearIssueCategoy();
        self.optyOptions = [];
        self.accountOptions = [];
      },

      isShowingCollapseFunc(accordionId) {
        let self = this;
        return _.get(self.isShowingCollapse, accordionId, false);
      },

      // Toggle Both Collapse A and B (by IDS list)
      toggleCollapses(ids) {
        ids.forEach((id) => {
          this.$root.$emit('bv::toggle::collapse', id)
        })
      },

      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }
        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        return false;
      },
      setPrimaryInfoInputValue(index) {
        let self = this;
        if (index > -1) {
          self.primaryInfoInputs.vertical = self.optyInfoObjList[index]['vertical'];
          self.primaryInfoInputs.industry = self.optyInfoObjList[index]['industry'];
        }
        /*
        else {
          self.primaryInfoInputs.modelList = self.all_model_list;
        }
         */
      },
      updateAutopilotChoice() {
        let self = this;
        let originalFlag = null;
        if (self.esTicketInfo !== null) {
          originalFlag = _.get(self.esTicketInfo, 'sa_selected_autopilot', null);
        }

        if ('Software - Autopilot' === _.get(self.primaryInfoInputs, 'typeOfIssue', null)) {
          _.set(self.esTicketInfo, 'sa_selected_autopilot', 'Yes'); //self.selectedAutopilot = 'Yes'
        } else {
          if ('Yes' === originalFlag) {
            //used to be need autopilot, yet change the issue type to another
            _.set(self.esTicketInfo, 'sa_selected_autopilot', null);
          }
        }
          /*
           *
      else {
         if (_.get(self.primaryInfoInputs, 'esPurpose', null) !== 'Asks to customize existing Getac products for special items.') {
            // self.selectedAutopilot = 'No';
            _.set(self.esTicketInfo, 'sa_selected_autopilot', 'No');
          } else {
            //self.selectedAutopilot = null;
            _.set(self.esTicketInfo, 'sa_selected_autopilot', null);
          }
       } */ // use computed attribute: displayAutopilotTick() to control the flag*/
      },

      resetAccountOpty() {
        let self = this;
        _.set(self.primaryInfoInputs, 'accountId', { 'value': '', 'text': '' });
        _.set(self.primaryInfoInputs, 'optyId', { 'value': '', 'text': '' });
        self.clearIssueCategoy();
        self.clearVerticalIndustryModelList();
        self.optyOptions = self.optyOptionsTmp;
        self.accountOptions = self.accountOptionsTmp;
      },
      getModelOptions(accountName, optyName) {
        let self = this;
        let requestData = {
          create_by: self.loginUser,
          username: self.loginUser,
          site: self.$session.get('user_site'),
          account_name: accountName,
          opty_name: optyName,
          account_id: _.get(self.primaryInfoInputs, 'accountId.value', null),
          opty_id: _.get(self.primaryInfoInputs, 'optyId.value', null),
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/options/models/', requestData)
          .then(res => {
            let result = res.data;
            //console.log(result);
            self.all_model_list = result.model_list;
            self.primaryInfoInputs.modelList = result.model_list;
            //console.log("self.primaryInfoInputs.modelList ==");
            //console.log(self.primaryInfoInputs.modelList);
            //_.set(self.primaryInfoInputs.modelList, result.model_list);
          })
          .finally(() => {
            console.log("COMPLETE /engineering-service/options/models/");
            self.searching = false;
            eventHub.$emit('loading', false);
          });
      },
      onChangeIssueCategory() {
        let self = this;
        if (_.get(self.primaryInfoInputs, 'esPurpose', null) !== null
          && _.get(self.primaryInfoInputs, 'esPurpose', null) !== ''
          && self.issueCategoryList !== null && _.size(self.issueCategoryList) !== 0) {

          let indexOfEsPurpose = _.findIndex(self.issueCategoryList, { 'request_type': _.get(self.primaryInfoInputs, 'esPurpose', null)  });
            //_.map(_.keys(_.pickBy(self.issueCategoryList, { request_type: _.get(self.primaryInfoInputs, 'esPurpose', null) })), Number);
          console.log("indexOfEsPurpose = ");
          console.log(indexOfEsPurpose);

          if (indexOfEsPurpose !== null && indexOfEsPurpose !== -1) {
            let issueTypeList = _.get(self.issueCategoryList[indexOfEsPurpose], 'issue_type', new Array());//_.mapValues(_.at(self.issueCategoryList, indexOfEsPurpose), function (v) { return v['issue_type']; });
            let sourceList = _.get(self.issueCategoryList[indexOfEsPurpose], 'source', new Array()); //_.mapValues(_.at(self.issueCategoryList, indexOfEsPurpose), function (v) { return v['source']; });
            self.typeOfIssueOptions = JSON.parse(JSON.stringify(issueTypeList));
            self.requirementStageOptions = JSON.parse(JSON.stringify(sourceList));
            _.set(self.primaryInfoInputs, 'typeOfIssue', null);
            _.set(self.primaryInfoInputs, 'requirementStage', null);
            /*
            if (_.get(self.primaryInfoInputs, 'esPurpose', null) !== 'Asks to customize existing Getac products for special items.') {
              console.log("No customization request, set autopilot flag to False");
              _.set(self.esTicketInfo, 'sa_selected_autopilot', 'No');
            } // use computed attribute: displayAutopilotTick() to control the flag*/
          }
        }
      },
      onChangeByAccount() {
        let self = this;
        if (_.get(self.primaryInfoInputs, 'accountId.value', '') !== ''
          && self.optyInfoObjList !== null) {
          let indexOfSameAccount = _.map(_.keys(_.pickBy(self.optyInfoObjList, { account_id: _.get(self.primaryInfoInputs, 'accountId.value', null) })), Number);
          console.log("indexOfSameAccount = ");
          console.log(indexOfSameAccount);
          let accountName = null;
          if (indexOfSameAccount !== null && _.size(indexOfSameAccount) > 0) {
            accountName = _.get(self.optyInfoObjList[indexOfSameAccount[0]], 'account_name', null);
            let optyList = _.mapValues(_.at(self.optyInfoObjList, indexOfSameAccount), function (v) { return v['opty_id']; });
            //console.log("optyList::");
            //console.log(optyList);
            //console.log(_.values(optyList));
            self.clearIssueCategoy();

            self.clearVerticalIndustryModelList();
            self.primaryInfoInputs.modelList = self.all_model_list;
            _.set(self.primaryInfoInputs,'optyId', { 'value': '', 'text': '' });
            _.set(self.primaryInfoInputs, 'modelList', self.all_model_list);
            let optyFilterOptions = _.filter(self.optyOptionsTmp, item => { return _.values(optyList).includes(item.value); })
            optyFilterOptions.unshift({ 'text': '', 'value': '' });
            //console.log(optyFilterOptions);
            _.set(self.optyOptions, optyFilterOptions);

            self.optyOptions = optyFilterOptions;
          } else {
            self.primaryInfoInputs.modelList = self.all_model_list;
          }
          if (_.get(self.primaryInfoInputs, 'accountId.value', '') === '') {
            self.primaryInfoInputs.optyId = { 'value': '', 'text': '' };
          }
          //console.log("accountName for self.getModelOptions() ::");
          //console.log(accountName);
          self.getModelOptions(accountName, null);
        }
      },
      onChangeByOpty() {
        let self = this;
        let optyName = null;
        let accountName = null;

        if (_.get(self.primaryInfoInputs, 'optyId', { 'value': '', 'text': '' }) !== { 'value': '', 'text': '' }
          && self.optyInfoObjList !== null) {
          let index = _.findIndex(self.optyInfoObjList, { 'opty_id': _.get(self.primaryInfoInputs, 'optyId.value', null) });

          if (index !== -1
            && _.get(self.primaryInfoInputs, 'optyId', { 'value': '', 'text': '' }) !== { 'value': '', 'text': '' }
            && _.get(self.optyInfoObjList[index], 'account_id', null) !== null) {
            self.primaryInfoInputs.accountId = { 'value': _.get(self.optyInfoObjList[index], 'account_id', null), 'text': _.get(self.optyInfoObjList[index], 'account_name', null) };
            optyName = _.get(self.optyInfoObjList[index], 'opty_name', null);
            accountName = _.get(self.optyInfoObjList[index], 'account_name', null);
            self.clearIssueCategoy();
            self.clearVerticalIndustryModelList();
            self.setPrimaryInfoInputValue(index);
            self.getModelOptions(accountName, optyName);
          } else {
            _.set(self.esTicketInfo, 'tech_info.model', null);
            self.getModelOptions(accountName, null);
            //self.primaryInfoInputs.modelList = self.all_model_list;
          }
        }
      },

      getOptions() {
        let self = this;
        _.set(self.esTicketInfo, 'primary_info.cooperate_rsm', _.get(self.primaryInfoInputs, 'rsm.value', null));
        let requestData = {
          create_by: self.loginUser,
          username: self.loginUser,
          rsm_name: _.get(self.esTicketInfo, 'primary_info.cooperate_rsm', null),
          site: self.$session.get('user_site')
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/options/opty-and-account/', requestData)
          .then(res => {
            let result = res.data;
            //console.log(result);
            if (result.opty_obj_list !== null && _.size(result.opty_obj_list) !== 0) {
              result.opty_obj_list = JSON.parse(result.opty_obj_list);
            }
             // ------ --- --- --- ---  BUILD ACCOUNT/OPTY OPTION LIST--- --- ---
            // result.opty_name_list = result.opty_name_list;
            // result.account_list = result.account_list;
            self.optyInfoObjList = result.opty_obj_list;
            self.all_model_list = result.model_list;

            /* new way:: build optyArray from B.E.*/
            if (result.opty_option !== null && _.size(result.opty_option) !== 0) {
              result.opty_option = JSON.parse(result.opty_option);
            }
            self.optyOptions = result.opty_option;
            self.optyOptionsTmp = result.opty_option;
            self.optyOptionsTmp.unshift({ 'text': '', 'value': '' });
            /* new way:: build accountOptions from B.E.*/

            /* new way:: build accountOptions from B.E.*/
            if (result.account_option !== null && _.size(result.account_option) !== 0) {
              result.account_option = JSON.parse(result.account_option);
            }
            self.accountOptions = result.account_option;
            self.accountOptionsTmp = result.account_option;
            self.accountOptionsTmp.unshift({ 'text': '', 'value': '' });

            //console.log(self.optyOptions);
            //console.log(self.accountOptions);
            /* END REGION */
          })
          .finally(() => {
            console.log("COMPLETE /engineering-service/options/opty-and-account/");
            self.resetAccountOpty();
            self.getIssueCategoryOptions();
            self.searching = false;
            eventHub.$emit('loading', false);
          });
      },

      getPage(callback) {
        let self = this;
        let optyIdInRequest = '0000';
        if (self.sfdcOptyEsId !== null && self.sfdcOptyEsId !== '') {
          optyIdInRequest = self.sfdcOptyEsId;
        }
        let requestData = {
          create_by: self.loginUser,
          username: self.loginUser,
          es_ticket_id: self.esId,
          opty_id: optyIdInRequest,
          site: self.$session.get('user_site'),
          es_under_opty_id: self.sfdcOptyId,
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        let urlByOptyId = self.$root.baseUrl + '/engineering-service/back-end/opty-id/';
        //let defaultOptyInfo = null;
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/back-end/opty-id/' + optyIdInRequest, requestData)
          .then(res => {
            let result = res.data;
            result.es_ticket_info = JSON.parse(result.es_ticket_info);
            if (result.default_opty_info !== null) {
              result.default_opty_info = JSON.parse(result.default_opty_info);
              self.defaultOptyInfo = result.default_opty_info;
            }
            // result.cooperate_rsm_option = result.cooperate_rsm_option;
            self.esTicketInfo = result.es_ticket_info;
            self.rsmOptions = result.cooperate_rsm_option;
            self.rsmOptions.unshift({ 'text': '', 'value': '' });
            self.ftieId = self.esTicketInfo.ftie_id;
            self.esId = self.esTicketInfo.es_id;
            self.sfdcOptyEsId = self.esTicketInfo.opty_obj_id;
          })
          .finally(() => {
            console.log("COMPLETE /engineering-service/back-end/opty-id/");
            self.resetAccountOpty();
            self.getIssueCategoryOptions();
            if (self.esTicketInfo !== null) {
              self.esTicketOriginalInfo = JSON.parse(JSON.stringify(self.esTicketInfo));
              self.selectedAutopilot = _.get(self.esTicketInfo, 'sa_selected_autopilot', null);
            }
            self.searching = false;
            self.actionEnable = self.checkActionEnable();
            if (self.defaultOptyInfo !== null
              && _.get(self.defaultOptyInfo, 'opty_name', null) !== null
              && _.get(self.defaultOptyInfo, 'opty_id', null) !== null
              && _.get(self.defaultOptyInfo, 'opty_owner_name', null) !== null) {
              //build default value
              self.primaryInfoInputs.optyId = { 'value': _.get(self.defaultOptyInfo, 'opty_id', null), 'text': _.get(self.defaultOptyInfo, 'opty_name', null)};
              self.primaryInfoInputs.accountId = { 'value': _.get(self.defaultOptyInfo, 'account_id', null), 'text': _.get(self.defaultOptyInfo, 'account_name', null) }; _.get(self.defaultOptyInfo, 'account_id', null);
              //self.onChangeByOpty();
              self.primaryInfoInputs.rsm = { 'value': _.get(self.defaultOptyInfo, 'opty_owner_name', null), 'text': _.get(self.defaultOptyInfo, 'opty_owner_name', null) };
              self.getModelOptions(_.get(self.defaultOptyInfo, 'account_name', null), _.get(self.defaultOptyInfo, 'opty_name', null));
            }
            if (self.esTicketInfo !== null) {
              self.esTicketInfo.es_ticket_status = 'New';
            }
            eventHub.$emit('loading', false);
            if (self.updateSuccessNotification !== null) {
              self.updateFailedNotification = null;
              self.$message.info(`${self.updateSuccessNotification}`);
            }
            else {
              if (self.updateFailedNotification !== null) {
                self.$message.error(`${self.updateFailedNotification}`);
              }
            }
          });
      },
      getIssueCategoryOptions() {
        //options/issue-category/
        let self = this;
        let requestData = {
          create_by: self.loginUser,
          username: self.loginUser,
        };
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/options/issue-category/', requestData)
          .then(res => {
            let result = res.data;
            result.category_option_list = JSON.parse(result.category_option_list);
            /**
             *        self.request_type = None
                      self.issue_type = None
                      self.source = None
             * */
            self.issueCategoryList = result.category_option_list;
            //self.whyNeedEsOptions = result.eto_request_type_list;
            self.whyNeedEsOptionsTmp = result.eto_request_type_list;
            //console.log("self.issueCategoryList:");
            //console.log(self.issueCategoryList);
            //console.log("self.whyNeedEsOptionsTmp:");
            //console.log(self.whyNeedEsOptionsTmp);
          })
          .finally(() => {
            console.log("COMPLETE /engineering-service/options/issue-category/");
          });
      },
      setEsPrimaryInfo() {
        let self = this;
        let account_name = '';
        let opty_name = '';

        if (_.get(self.defaultOptyInfo, 'opty_id', null)) {
          opty_name = _.get(self.defaultOptyInfo, 'opty_name', null);
          account_name = _.get(self.defaultOptyInfo, 'account_name', null);
        } else {
          let account = _.find(self.accountOptions, { value: _.get(self.primaryInfoInputs, 'accountId.value', null) });
          if (account) {
            account_name = account.text;
          }
          let opty = _.find(self.optyOptions, { value: _.get(self.primaryInfoInputs, 'optyId.value', null) });
          if (opty) {
            opty_name = opty.text;
          }
        }
        _.set(self.esTicketInfo, 'primary_info.cooperate_rsm', _.get(self.primaryInfoInputs, 'rsm.value', null));
        _.set(self.esTicketInfo, 'primary_info.account_id', _.get(self.primaryInfoInputs, 'accountId.value', null));
        _.set(self.esTicketInfo, 'primary_info.opty_id', _.get(self.primaryInfoInputs, 'optyId.value', null));
        _.set(self.esTicketInfo, 'primary_info.account_name', account_name);
        _.set(self.esTicketInfo, 'primary_info.opty_name', opty_name);
        _.set(self.esTicketInfo, 'primary_info.es_purpose', _.get(self.primaryInfoInputs, 'esPurpose', null));
        _.set(self.esTicketInfo, 'primary_info.matching_issue', _.get(self.primaryInfoInputs, 'typeOfIssue', null));
        _.set(self.esTicketInfo, 'primary_info.requirement_stage', _.get(self.primaryInfoInputs, 'requirementStage', null));
        if (self.displayAutopilotTick === false) {
          _.set(self.esTicketInfo, 'sa_selected_autopilot', null);
        }
      },

      postEsData(action) {
        let self = this;
        let defaultGmlSaMembers = ['tongyi.xu', 'koko.wu', 'xianglong.li', 'tracy.lu', 'bor.tsang']
        let create_by = self.loginUser;
        if (defaultGmlSaMembers.includes(self.login_user_name)) {
          create_by = 'gmlsa.gml';
        }
        _.set(self.esTicketInfo, 'sector_solution_info.industry', _.get(self.primaryInfoInputs, 'industry', null));
        _.set(self.esTicketInfo, 'sector_solution_info.vertical', _.get(self.primaryInfoInputs, 'vertical', null));
        _.set(self.esTicketInfo, 'action', 'New');
        _.set(self.esTicketInfo, 'create_by', create_by);
        self.setEsPrimaryInfo();
        let requestData = {
          input_info: JSON.parse(JSON.stringify(self.esTicketInfo)),
          action: 'New',
          create_by: create_by,
          username: create_by,
          site: self.$session.get('user_site')
        }
        self.searching = true;
        eventHub.$emit('loading', true);
        let save_success = false;
        let es_id = null;
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/save/', requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'save_success', false)) {
              save_success = _.get(result, 'save_success', false);
              es_id = result.es_id;
              console.log("result.save_success::");
              console.log(_.get(result, 'save_success', false));

              self.updateFailedNotification = null;
              if (action === 'save' || _.get(self.esTicketInfo, 'ftie_id', null) !== null) {
                if ('new' === _.get(requestData, 'action', '')) {
                  self.updateSuccessNotification = "The engineering service has been initiated but not submit yet! Just few steps to complete by clicking the submit button.";
                }
                else {
                  self.updateSuccessNotification = "The engineering service has been updated successfully!";
                }

              }
              else {
                self.updateSuccessNotification = null;
              }

            }else {
              self.updateSuccessNotification = null;
              self.updateFailedNotification = `${action} engineering service failed!`;
              // self.$message.exception(result.error_msg);
              self.$message.error(`${self.updateFailedNotification}`);
            }
          })
          .finally(() => {
            console.log("COMPLETE /engineering-service/" + action);
            self.searching = false;
            self.actionEnable = self.checkActionEnable();
            eventHub.$emit('loading', false);
            if (save_success) {
              if (self.updateSuccessNotification !== null) {
                self.$message.info(`${self.updateSuccessNotification}`);
              }
              window.location.href = self.frontEndUrlToUse + 'engineering-service/opty-id/'+ es_id;
            }
          });
      },
      saveData() {
        this.postEsData('save');
      },
      lengthValidate() {
        let self = this;
        let validateColumnsMax255 = ['close_reason', 'tech_info.impact', 'tech_info.third_party_application', 'customization_info.eco_system'];
        let validateColumnsMax60 = ['sector_solution_info.user_group'];
        let validateColumns = ['tech_info.user_scenario', 'tech_info.configuration']; // MAX = 1000
        let validateColumnsMax2000 = ['tech_info.es_issue']; // MAX = 2000

        /* MAX = 60 */
        for (var i = 0; i < validateColumnsMax60.length; i++) {
          if (_.get(self.esTicketInfo, validateColumnsMax60[i], '') !== '' && _.get(self.esTicketInfo, validateColumnsMax60[i], '') !== null) {
            if (_.get(self.esTicketInfo, validateColumnsMax60[i], '').length > 60) {
              let text = `The max length of 60 characters in ${validateColumnsMax60[i]} is reached. You typed in ${_.get(self.esTicketInfo, validateColumnsMax60[i], '').length} characters`;
              self.$message.warning(text, 'Max Length Reached: User Group');
              return false;
            }
          }
        }

        /* MAX = 255 */
        for (var i = 0; i < validateColumnsMax255.length; i++) {
          if (_.get(self.esTicketInfo, validateColumnsMax255[i], '') !== '' && _.get(self.esTicketInfo, validateColumnsMax255[i], '') !== null) {
            if (_.get(self.esTicketInfo, validateColumnsMax255[i], '').length > 255) {
              let text = `The max length of 255 characters in ${validateColumnsMax255[i]} is reached. You typed in ${_.get(self.esTicketInfo, validateColumnsMax255[i], '').length} characters`;

              self.$message.warning(text, 'Max Length Reached');
              return false;
            }
          }
        }

        /* MAX = 300, 1000 */
        for (var i = 0; i < validateColumns.length; i++) {
          if (_.get(self.esTicketInfo, validateColumns[i], '') !== '' && _.get(self.esTicketInfo, validateColumns[i], '') !== null) {
            if (validateColumns[i] === 'tech_info.user_scenario' && _.get(self.esTicketInfo, validateColumns[i], '').length > 1000) {
              let text = `The max length of 1000 characters in Step 2 (user scenario or configuration) is reached. You typed in ${_.get(self.esTicketInfo, validateColumns[i], '').length} characters`;

              self.$message.warning(text, 'Max Length Reached in Step 2');
              return false;
            }
            /*
            if (validateColumns[i] === 'tech_info.es_issue' && _.get(self.esTicketInfo, validateColumns[i], '').length > 1000) {
              let text = `The max length of 1000 characters in Engineering Service Issue / Requirement is reached. You typed in ${_.get(self.esTicketInfo, validateColumns[i], '').length} characters`;

              self.$message.warning(text, 'Max Length Reached: Engineering Service Issue');
              return false;
            }*/
          }
        }

        //
        /* MAX = 2000 */
        for (var i = 0; i < validateColumnsMax2000.length; i++) {
          /*
          if (validateColumns[i] === 'tech_info.es_issue' && _.get(self.esTicketInfo, validateColumns[i], '').length > 2000) {
            let text = `The max length of 2000 characters in Engineering Service Issue / Requirement is reached. You typed in ${_.get(self.esTicketInfo, validateColumns[i], '').length} characters`;

            self.$message.warning(text, 'Max Length Reached: Engineering Service Issue');
            return false;
          }*/

          if (_.get(self.esTicketInfo, validateColumnsMax2000[i], '') !== '' && _.get(self.esTicketInfo, validateColumnsMax2000[i], '') !== null) {
            if (_.get(self.esTicketInfo, validateColumnsMax2000[i], '').length > 2000) {
              let text = `The max length of 2000 characters in ${validateColumnsMax2000[i]} is reached. You typed in ${_.get(self.esTicketInfo, validateColumnsMax2000[i], '').length} characters`;

              self.$message.warning(text, 'Max Length Reached');
              return false;
            }
          }
        }

        // !! ALL LOOP COMPLETED, PASS THE LENGTH VALIDATION !!
        return true;
      },
      validate() {
        let self = this;
        let validate_columns = ['rsm', 'accountId', 'esPurpose', 'typeOfIssue', 'requirementStage']
        let validate_empty = true;
        let missingColStr = '';
        for (var i = 0; i < validate_columns.length; i++) {
          if (self.primaryInfoInputs[validate_columns[i]] == null) {
            validate_empty = false;
            if (missingColStr === '') {
              missingColStr = missingColStr + validate_columns[i];
            }
            else {
              missingColStr = missingColStr + ', ' + validate_columns[i]
            }
            //break;
          }
        }
        if (!validate_empty) {
          let warningMsg = `Please ensure you input the required columns in Primary Info Section: ${missingColStr}`
          self.$message.warning(`${warningMsg}`, 'Missing Required Fields');
        }
        return validate_empty;
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/engineering-service-process/CreateNewEngineeringService.vue